import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, output, input } from "@angular/core";
import { XmlReportPrintComponent, HighChartDataBase } from "@otimo/highcharts-xmlreport";
import { PortalChartConfig } from "@root/models/portalChartConfig";

/**
 * Ger en snygg utskrift med en sida för respektive del
 * (Diagram / Detaljerad tabell / Förklaring / Urval)
 **/
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "report-print",
    templateUrl: "./report-print.component.html",
    imports: [XmlReportPrintComponent]
})
export class ReportPrintComponent {

    config = input<PortalChartConfig>();
    printDataIsLoaded = output<boolean>();

    public chartData: HighChartDataBase;

    public receiveChartData(chartData): void {
        this.chartData = chartData;
        this.printDataIsLoaded.emit(true);
    }
}
